import { create } from 'zustand'
import type { ProjectRole, ProjectVisibility } from '@/lib/projectRoles'

interface ProjectAccessInput {
  userRole: ProjectRole | null
  visibility: ProjectVisibility | null
}

export interface ProjectAccessStore extends ProjectAccessInput {
  setProjectAccess: (access: ProjectAccessInput) => void
  resetProjectAccess: () => void
  canEditProject: () => boolean
}

export function roleCanEditProject(role: ProjectRole | null | undefined): boolean {
  return role === 'owner' || role === 'editor'
}

export function canEditProjectAccess(access: ProjectAccessInput): boolean {
  // The backend join path assigns link_edit visitors role='editor'. Keep
  // visibility in the store so this assumption is explicit and testable.
  return roleCanEditProject(access.userRole)
}

export const useProjectAccessStore = create<ProjectAccessStore>((set, get) => ({
  userRole: null,
  visibility: null,
  setProjectAccess: ({ userRole, visibility }) => set({ userRole, visibility }),
  resetProjectAccess: () => set({ userRole: null, visibility: null }),
  canEditProject: () =>
    canEditProjectAccess({
      userRole: get().userRole,
      visibility: get().visibility,
    }),
}))

export const selectCanEditProject = (state: ProjectAccessStore): boolean => canEditProjectAccess(state)
